// The icon names the code uses (Font Awesome's) and the Phosphor icon
// each one shows. After a change here, run `yarn icons` to update the
// shapes in icon_paths.js.
export const ICONS = {
  'address-book': 'address-book',
  'align-right': 'closed-captioning',
  'angles-down': 'caret-double-down',
  'angles-left': 'caret-double-left',
  'angles-right': 'caret-double-right',
  'arrow-line-up': 'arrow-line-up',
  'arrows-rotate': 'arrows-clockwise',
  ban: 'prohibit',
  bars: 'list',
  'bars-staggered': 'rows',
  basketball: 'basketball',
  bell: 'bell',
  'bell-ringing': 'bell-ringing',
  bookmark: 'bookmark-simple',
  bullhorn: 'megaphone',
  bus: 'bus',
  'cake-candles': 'cake',
  camera: 'camera',
  'chart-line': 'chart-line',
  check: 'check',
  'check-double': 'checks',
  'chevron-down': 'caret-down',
  'chevron-left': 'caret-left',
  'chevron-right': 'caret-right',
  'chevron-up': 'caret-up',
  'circle-half-stroke': 'circle-half',
  'circle-info': 'info',
  'circle-nodes': 'graph',
  'circle-notch': 'circle-notch',
  'circle-play': 'play-circle',
  'circle-plus': 'plus-circle',
  'circle-question': 'question',
  'circle-xmark': 'x-circle',
  city: 'buildings',
  clock: 'clock',
  'clock-rotate-left': 'clock-counter-clockwise',
  code: 'code',
  compass: 'compass',
  comments: 'chats-circle',
  desktop: 'desktop',
  'door-open': 'door-open',
  'down-left-and-up-right-to-center': 'arrows-in-simple',
  download: 'download-simple',
  ellipsis: 'dots-three',
  'ellipsis-vertical': 'dots-three-vertical',
  envelope: 'envelope-simple',
  eye: 'eye',
  'eye-dropper': 'eyedropper',
  'eye-slash': 'eye-slash',
  'face-smile': 'smiley',
  'face-smile-beam': 'smiley',
  file: 'file',
  'file-arrow-down': 'file-arrow-down',
  'file-arrow-up': 'file-arrow-up',
  'file-lines': 'file-text',
  'file-pen': 'note-pencil',
  filter: 'funnel',
  flag: 'flag',
  folder: 'folder',
  'folder-open': 'folder-open',
  'folder-tree': 'tree-structure',
  font: 'text-aa',
  gauge: 'gauge',
  'gauge-high': 'shield-check',
  gear: 'gear-six',
  gears: 'gear-fine',
  globe: 'globe',
  hand: 'hand',
  hashtag: 'hash',
  'hourglass-half': 'hourglass-medium',
  house: 'house',
  'ice-cream': 'ice-cream',
  igloo: 'map-pin',
  image: 'image',
  info: 'info',
  key: 'key',
  language: 'translate',
  'laptop-code': 'laptop',
  lightbulb: 'lightbulb',
  link: 'link',
  list: 'list-bullets',
  lock: 'lock',
  'lock-open': 'lock-open',
  'magnifying-glass': 'magnifying-glass',
  'magnifying-glass-plus': 'magnifying-glass-plus',
  message: 'chat-circle',
  minus: 'minus',
  moon: 'moon',
  music: 'music-notes',
  'note-sticky': 'note',
  paperclip: 'paperclip',
  pause: 'pause',
  paw: 'paw-print',
  pen: 'pencil-simple-line',
  'pen-to-square': 'pencil-simple',
  'people-group': 'users-three',
  play: 'play',
  plug: 'plug',
  'plug-circle-xmark': 'plugs',
  plus: 'plus',
  'quote-right': 'quotes',
  reply: 'arrow-bend-up-left',
  'reply-to': 'arrow-elbow-down-right',
  retweet: 'repeat',
  'right-from-bracket': 'sign-out',
  'right-to-bracket': 'sign-in',
  robot: 'robot',
  rss: 'rss',
  server: 'hard-drives',
  'share-nodes': 'share-network',
  sliders: 'sliders-horizontal',
  'square-plus': 'arrows-out-simple',
  'square-poll-horizontal': 'chart-bar',
  star: 'star',
  stop: 'stop',
  'suitcase-rolling': 'truck',
  sun: 'sun',
  thumbtack: 'push-pin',
  'tower-broadcast': 'broadcast',
  'trash-can': 'trash',
  'triangle-exclamation': 'warning',
  'up-right-and-down-left-from-center': 'arrows-out-simple',
  'up-right-from-square': 'arrow-square-out',
  upload: 'upload-simple',
  user: 'user',
  'user-plus': 'user-plus',
  users: 'users',
  video: 'video-camera',
  'volume-high': 'speaker-high',
  'window-minimize': 'minus',
  'window-restore': 'palette',
  wrench: 'wrench',
  xmark: 'x',
}

// Icons the app draws filled (['fas', name]); only these ship a fill shape.
// A spec checks the code against this list.
export const FILLED = ['bell-ringing', 'bookmark', 'pause', 'play', 'star']

// older names still used in the code
export const ALIASES = {
  add: 'plus',
  'angle-double-down': 'angles-down',
  'angle-double-left': 'angles-left',
  'angle-double-right': 'angles-right',
  'basketball-ball': 'basketball',
  'birthday-cake': 'cake-candles',
  cancel: 'ban',
  chain: 'link',
  close: 'xmark',
  cog: 'gear',
  'compress-alt': 'down-left-and-up-right-to-center',
  edit: 'pen-to-square',
  'ellipsis-h': 'ellipsis',
  'ellipsis-v': 'ellipsis-vertical',
  'exclamation-triangle': 'triangle-exclamation',
  'expand-alt': 'up-right-and-down-left-from-center',
  'external-link-alt': 'up-right-from-square',
  feed: 'rss',
  'file-download': 'file-arrow-down',
  'file-upload': 'file-arrow-up',
  history: 'clock-rotate-left',
  home: 'house',
  'info-circle': 'circle-info',
  'play-circle': 'circle-play',
  'plus-square': 'square-plus',
  'poll-h': 'square-poll-horizontal',
  remove: 'xmark',
  search: 'magnifying-glass',
  'search-plus': 'magnifying-glass-plus',
  'share-alt': 'share-nodes',
  'sign-in-alt': 'right-to-bracket',
  'sign-out-alt': 'right-from-bracket',
  smile: 'face-smile',
  'sticky-note': 'note-sticky',
  stream: 'bars-staggered',
  'tachometer-alt': 'gauge-high',
  times: 'xmark',
  'trash-alt': 'trash-can',
  'volume-up': 'volume-high',
  warning: 'triangle-exclamation',
}
